import { render, staticRenderFns } from "./chelianwang.vue?vue&type=template&id=3ebe9b02&scoped=true&"
import script from "./chelianwang.vue?vue&type=script&lang=js&"
export * from "./chelianwang.vue?vue&type=script&lang=js&"
import style0 from "./chelianwang.vue?vue&type=style&index=0&id=3ebe9b02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebe9b02",
  null
  
)

export default component.exports